// extracted by mini-css-extract-plugin
var _1 = "BookChapter__blueButton--HeWmi";
var _2 = "BookChapter__border--SuKWH";
var _3 = "BookChapter__bottomNav--YkTS8";
var _4 = "BookChapter__buttonBg--QrJSg";
var _5 = "BookChapter__buttonText--Fh4mp";
var _6 = "BookChapter__buttonWrapper--I1UPp";
var _7 = "BookChapter__demoHighlight--ajPXA BookChapter__icon--q5zyV";
var _8 = "BookChapter__icon--q5zyV";
var _9 = "BookChapter__line--Xk2tn";
var _a = "BookChapter__main--gQW2d LibraryGeneral__robotoSlab--CmKt3 CoreGeneral__robotoSlab--X8lgW";
var _b = "BookChapter__navButton--MX8G6";
var _c = "BookChapter__octagon--Zh7k_";
var _d = "BookChapter__placeholder--hEpll";
var _e = "BookChapter__scroll--t44q8";
var _f = "BookChapter__tools--ZXZSP";
var _10 = "BookChapter__topBumper--gtC_0";
var _11 = "BookChapter__zoom--TCkKv";
export { _1 as "blueButton", _2 as "border", _3 as "bottomNav", _4 as "buttonBg", _5 as "buttonText", _6 as "buttonWrapper", _7 as "demoHighlight", _8 as "icon", _9 as "line", _a as "main", _b as "navButton", _c as "octagon", _d as "placeholder", _e as "scroll", _f as "tools", _10 as "topBumper", _11 as "zoom" }
